export default "__VITE_PUBLIC_ASSET__90a901c9__"